import angular from 'angular';

const services = angular.module('applicationModule.webSectionsServices', []);

services.factory('WebSections', ['WebSectionsAPI', 'Upload', 'AppsoupAPI', function (WebSectionsAPI, Upload, AppsoupAPI) {
    'use strict';
    const checkFiles = (file) => {
        const files = [];
        const names = [];
        if (angular.isDefined(file)) {
            files.push(file);
            names.push('file');
        }
        return {files, names};
    };

        return {
            all: function (appId, pageId, layout) {
                return WebSectionsAPI.all(appId, pageId, layout)
                    .then(function (response) {
                        return response.data;
                    });
            },
            get: function (id, appId) {
                return WebSectionsAPI.get(id, appId);
            },
            save: function (data, file, editMode) {
                var API_URL = AppsoupAPI.API_URL + '/app/web-sections';
                if (editMode) {
                    if (angular.isDefined(file)) {
                        var files = checkFiles(file);
                        var newfields = angular.extend(data, {_method: 'PUT'});

                        return Upload.upload({
                            url: API_URL + '/' + data.id,
                            method: 'POST',
                            sendObjectsAsJsonBlob: false,
                            fields: newfields,
                            file: files.files,
                            fileFormDataName: files.names
                        });
                    }
                } else {
                    if (angular.isDefined(file)) {
                        files = checkFiles(file);

                        return Upload.upload({
                            url: API_URL,
                            method: 'POST',
                            sendObjectsAsJsonBlob: false,
                            fields: data,
                            file: files.files,
                            fileFormDataName: files.names
                        });
                    }
                }

                return WebSectionsAPI.store(data, editMode);
            },
            remove: function (id, appId) {
                return WebSectionsAPI.remove(id, appId);
            },
            create: function (appId, container, pageId) {
                return WebSectionsAPI.create(appId, container, pageId);
            },
            changeOrder: function (data) {
                return WebSectionsAPI.changeOrder(data);
            },
            copy: function (data) {
                return WebSectionsAPI.copy(data);
            },
            changeOrderExtreme: function (data) {
                return WebSectionsAPI.changeOrderExtreme(data);
            },
            changeSectionsOrder: function (data) {
                return WebSectionsAPI.changeSectionsOrder(data);
            }
        };
    }]);

    services.service('WebSectionsAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {

        var API_URL = AppsoupAPI.API_URL + '/app/web-sections/';

        this.all = function (appId) {
            return $http.get(API_URL, {params: {application_id: appId}});
        };

        this.get = function (id) {
            return $http.get(API_URL + id);
        };

        this.store = function (data, editMode) {
            if (editMode) {
                return $http.put(API_URL + data.id, data);
            } else {
                return $http.post(AppsoupAPI.API_URL + '/app/web-sections', data);
            }
        };

        this.remove = function (id) {
            return $http.delete(API_URL + id);
        };

        this.create = function (appId, container, pageId) {
            return $http.get(API_URL + 'create', {params: {application_id: appId, container: container, page_id: pageId}});
        };

        this.changeOrder = function (data) {
            var url = API_URL + 'change-order/';

            return $http.post(url, data);
        };

        this.copy = function (data) {
            var url = API_URL + 'copy/';

            return $http.post(url, data);
        };

        this.changeOrderExtreme = function (data) {
            var url = API_URL + 'change-order-extreme/';

            return $http.post(url, data);
        };

        this.changeSectionsOrder = function (data) {
            var url = API_URL + 'change-sections-order/';

            return $http.post(url, data);
        };

    }]);

export default services;